import clsx from 'clsx';
import { InputLabelGhost } from '@//components/InputLabel';
import { RangeSlider, type RangeSliderProps, type SingleRange } from '@//components/RangeSlider';
import { Selectfield, type SelectfieldProps } from '../Selectfield';
import styles from './RangeSliderSelectfield.module.scss';

interface RangeSliderSelectfieldProps {
  id: string;
  label: string;
  rangeSlider: RangeSliderProps<SingleRange>;
  selectfield: SelectfieldProps;
  variant?: 'default' | 'compact';
}

export const RangeSliderSelectfield = ({
  id,
  label,
  rangeSlider,
  selectfield,
  variant = 'default',
}: RangeSliderSelectfieldProps) => (
  <fieldset
    className={clsx(styles.group, {
      [styles.groupCompact]: variant === 'compact',
    })}
    aria-describedby={id}
  >
    <legend className="sr-only" id={id}>
      {label}
    </legend>
    <Selectfield {...selectfield} />
    <div className={styles.rangeSlider}>
      {variant === 'compact' && <InputLabelGhost className={styles.ghostLabel} />}
      <div className={styles.inputAlignment}>
        <RangeSlider {...rangeSlider} />
      </div>
    </div>
  </fieldset>
);
